export default __webpack_public_path__ + "static/media/dress2.3db0b3c7.jpeg";